export const safeJsonParse = (json = '', defaultValue: any = {}) => {
    try {
        if (!json) {
            return defaultValue;
        }
        return JSON.parse(json);
    } catch (error) {
        console.error(error);
        return defaultValue;
    }
};
